// src/pages/etc/mailAlert/MailAlertPage.jsx
// ✅ "공용메일 알림" — ApprovalInbox.jsx와 동일한 탭 패턴(useState + 인라인 스타일
// 탭 버튼, 별도 <Tabs> 공용 컴포넌트 없음이 이 프로젝트 관례).
import React, { useEffect, useState } from "react";
import MailAlertInboxTab from "./MailAlertInboxTab";
import MailAlertSettingsTab from "./MailAlertSettingsTab";

const TAB_STYLE = {
  padding: "10px 20px", border: "none", background: "#fff", cursor: "pointer",
  fontSize: 14, fontWeight: 600, color: "#495057", borderBottom: "3px solid transparent",
  whiteSpace: "nowrap",
};
const TAB_ACTIVE_STYLE = { ...TAB_STYLE, color: "#4a90e2", borderBottom: "3px solid #4a90e2" };

export default function MailAlertPage() {
  const [tab, setTab] = useState("inbox"); // "inbox" | "settings"

  useEffect(() => { document.title = "공용메일 알림"; }, []);

  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ margin: "0 0 12px", whiteSpace: "nowrap" }}>📧 공용메일 알림</h2>
      <div style={{ display: "flex", gap: 4, borderBottom: "1px solid #dee2e6", marginBottom: 16 }}>
        <button style={tab === "inbox" ? TAB_ACTIVE_STYLE : TAB_STYLE} onClick={() => setTab("inbox")}>
          📥 수신 알림함
        </button>
        <button style={tab === "settings" ? TAB_ACTIVE_STYLE : TAB_STYLE} onClick={() => setTab("settings")}>
          ⚙️ 설정
        </button>
      </div>
      {/* onOpenInbox — 설정 탭의 조회 이력에서 매칭 회차를 누르면 알림함으로 넘어간다.
          탭 상태가 여기 있으므로 콜백으로 내려준다. */}
      {tab === "inbox" ? <MailAlertInboxTab /> : <MailAlertSettingsTab onOpenInbox={() => setTab("inbox")} />}
    </div>
  );
}
